<template>
    <div class="sale">
        <el-form size="small" :model="searchData" :inline="true">
            <el-form-item v-if="searchData.type_id === 2">
                <el-select size="small" v-model="searchData.user_id" placeholder="销售员" clearable>
                    <el-option
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"
                        v-for="item in userData.list"
                    ></el-option>
                </el-select>
            </el-form-item>
            <el-form-item>
                <el-input
                    v-model="searchData.customer_name"
                    placeholder="客户名称/联系人"
                    clearable
                ></el-input>
            </el-form-item>
            <el-form-item>
                <el-date-picker
                    v-model="searchData.timer"
                    type="daterange"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    value-format="yyyy-MM-dd"
                    align="right"
                    unlink-panels
                    clearable
                    :picker-options="pickerOptions"
                ></el-date-picker>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" plain icon="el-icon-search" @click="SearchFollow"
                    >搜索</el-button
                >
            </el-form-item>
        </el-form>
        <div class="card">
            <div class="list" v-loading="followData.loading.list">
                <el-row class="list-control">
                    <el-col :span="24">
                        <el-radio-group
                            size="small"
                            v-model="searchData.type_id"
                            @change="SearchFollow"
                        >
                            <el-radio-button :label="1">我的跟进记录</el-radio-button>
                            <el-radio-button :label="2">全部跟进记录</el-radio-button>
                        </el-radio-group>
                    </el-col>
                </el-row>
                <div class="list-table">
                    <el-table :data="followData.list" stripe style="width: 100%">
                        <el-table-column prop="cname" label="客户" width="240"></el-table-column>
                        <el-table-column
                            prop="communicate_record"
                            label="跟进内容"
                        ></el-table-column>
                        <el-table-column label="跟进时间" width="180">
                            <template slot-scope="scope">{{
                                scope.row.updated_at | $moment
                            }}</template>
                        </el-table-column>
                        <el-table-column width="60">
                            <template slot-scope="scope">
                                <div class="t-right">{{ scope.row.uname }}</div>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
                <div class="list-pagination">
                    <el-pagination
                        background
                        layout="total, prev, pager, next, sizes"
                        :current-page.sync="followData.pages.page"
                        :page-sizes="[10, 20, 50, 100, 200, 500, 1000]"
                        :page-size="followData.pages.pagesize"
                        :total="followData.pages.total"
                        @size-change="GetSize"
                        @current-change="GetCurrent"
                    ></el-pagination>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { UserData } from '@/plugin/User'
export default {
    inject: ['reload'],
    mixins: [UserData],
    data() {
        return {
            pickerOptions: {
                shortcuts: [
                    {
                        text: '昨天',
                        onClick(picker) {
                            const start = new Date(),
                                end = new Date()
                            start.setTime(start.getTime() - 3600 * 1000 * 24)
                            end.setTime(end.getTime() - 3600 * 1000 * 24)
                            picker.$emit('pick', [start, end])
                        }
                    },
                    {
                        text: '今天',
                        onClick(picker) {
                            const start = new Date(),
                                end = new Date()
                            picker.$emit('pick', [start, end])
                        }
                    }
                ]
            },
            userData: {
                list: [],
                pages: {
                    page: 1,
                    pagesize: 9999
                }
            },
            searchData: {
                type_id: 1,
                user_id: null,
                customer_name: null,
                timer: []
            },
            followData: {
                loading: {
                    list: false
                },
                list: [],
                pages: {
                    page: 1,
                    pagesize: 10,
                    total: 0
                }
            }
        }
    },
    created() {
        this.$nextTick(() => {})
    },
    mounted() {
        this.$nextTick(() => {
            this.GetFollow()
        })
    },
    watch: {
        'searchData.type_id'(val) {
            this.searchData.user_id = null
            if (val === 2 && !this.userData.list.length) {
                this.GetUser()
            }
        }
    },
    methods: {
        // 员工
        GetUser() {
            this.GetUserData({
                data: {
                    ...this.userData.pages,
                    order: 'asc'
                }
            }).then(res => {
                this.userData.list = res.list
            })
        },
        // 查询
        SearchFollow() {
            this.followData.pages.page = 0
            this.GetFollow()
        },
        // 订单列表
        GetFollow() {
            this.followData.loading.list = true
            this.$request({
                url: '/api/v1/followlist',
                params: {
                    ...this.searchData,
                    ...this.followData.pages
                }
            }).then(res => {
                if (!res.status) {
                    this.followData.loading.list = false
                    this.followData.list = res.data.list
                    this.followData.pages.total = parseInt(res.data.total)
                } else {
                    this.$message.error(res.message || '操作失败')
                }
            })
        },
        GetSize(val) {
            this.followData.pages.pagesize = val
            this.GetFollow()
        },
        GetCurrent(val) {
            this.followData.pages.page = val
            this.GetFollow()
        }
    }
}
</script>

<style scoped lang="less">
@import '~@/assets/css/common.less';
@import '~@/assets/css/list.less';
</style>
